import api from 'modules/api';

export const getQuestionnaireRequest = () => api.get('/questionnaire');

export const getQuestionnaireAnswersRequest = () => {
  return api.get(`/questionnaire/answers`);
};

export const setDraftQuestionnaireAnswersRequest = ({ data }) => {
  return api.post(`/questionnaire/answers/draft`, { quizAnswers: data });
};

export const saveQuestionnaireAnswersRequest = ({ data }) => {
  return api.post(`/questionnaire/answers`, { quizAnswers: data });
};

export const confirmQuestionnaireRequest = () => {
  return api.patch(`/questionnaire/confirm`, { confirm: true });
};

export const getUserQuestionnaireAnswersRequest = ({ userId, payload }) => {
  return api.get(`/questionnaire/answers/${userId}`, { params: payload });
};

export const downloadUserQuestionnairesRequest = ({ userId }) => {
  return api.get(`/questionnaire/download/answers/${userId}`);
};
